var map = {
	"./icon-pdf.png": 1057
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1902;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/filetype-icons ^\.\/.*$
// module id = 1902
// module chunks = 17